import { systemAdminRoutes } from "features/system-admin/routes";
import { AppRoute } from "shared/types/AppRoute";

export const mainRoutes: AppRoute[] = [...systemAdminRoutes];
